import { observer } from 'mobx-react-lite'
import { Button, ButtonCopy, IconButton, Label, TextFieldWithLabel, Typography } from 'shared/ui'
import { useWidgetChatContext } from 'pages/settings/pages/widgetChat/context/widgetChatContext'
import { WidgetChatCard } from 'pages/settings/pages/widgetChat/ui/WidgetChatCard'
import styles from './styles.module.scss'

const DOMAIN_PLACEHOLDER = 'example.com'

export const InstallBlock = observer(() => {
  const { installBlockStore } = useWidgetChatContext()
  const {
    displayList,
    setDomainAt,
    addDomainSlot,
    removeDomainAt,
    validateDomainAt,
    getDomainErrorAt,
  } = installBlockStore

  return (
    <>
      <WidgetChatCard
        blockId='3'
        title='Install'
        description='Add your website domain where the widget should appear. Then copy and paste the tracking JavaScript code into every page of your site, just before the </body> tag.'
      />
      <Label label={{ text: 'Website domain' }} marginBottom={'-4px'} marginTop={'12px'} />
      <div className={styles.domainList}>
        {displayList.map((domainValue, index) => (
          <div key={index} className={styles.domainRow}>
            <div className={styles.domainInput}>
              <TextFieldWithLabel
                textFieldProps={{
                  value: domainValue,
                  onChange: (value) => setDomainAt(index, value),
                  onBlur: () => validateDomainAt(index),
                  InputProps: { placeholder: DOMAIN_PLACEHOLDER },
                }}
                errorMessage={getDomainErrorAt(index) ?? undefined}
              />
            </div>
            {displayList.length > 1 && (
              <IconButton
                icon='close'
                size='medium'
                color='secondary'
                variant='icon'
                onClick={() => removeDomainAt(index)}
                ariaLabel='Delete Domain'
                className={styles.deleteButton}
              />
            )}
          </div>
        ))}
      </div>
      <div className={styles.addButtonWrap}>
        <Button
          className={styles.addButton}
          text='Add domain'
          typeBtn='text'
          icon='add'
          contained='secondary'
          intent='default'
          type='button'
          onClick={addDomainSlot}
        />
      </div>
      <div className={styles.bottomBlock}>
        <Typography
          ariaLabel='InstallBlock_JavaScriptCode'
          variant='body-md-semibold'
          color='var(--content-primary-primary)'
          marginBottom={'20px'}
        >
          JavaScript Code
        </Typography>
        {installBlockStore.scriptSnippet && (
          <>
            <Typography
              className={styles.scriptPreview}
              ariaLabel='InstallBlock_EmbedScript'
              variant='body-md-regular'
              color='var(--content-primary-secondary)'
            >
              {installBlockStore.scriptSnippet}
            </Typography>
            <div className={styles.copyButtonWrap}>
              <ButtonCopy
                value={installBlockStore.scriptSnippet}
                buttonProps={{
                  typeBtn: 'contained',
                  contained: 'tertiary',
                  intent: 'default',
                  fullWidth: true,
                  size: 'medium',
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  )
})
